<template lang="pug">
app-page( title="Экспертиза" :fabItems="fabItems" )
  app-toolbar( title="Список регионов" )
  app-empty-list( v-if="!hasRegions" ) Список пуст
  app-group-animation
    app-group-item(v-for="region in regions" :key="region.id" cols="4")
      expert-region-card( :region="region" @click.native="openRegionActionsDialog(region)" )

  expert-add-region-dialog( v-model="isAddRegionDialogOpened" @save="saveRegion" )
  expert-edit-region-dialog( v-model="isEditRegionDialogOpened" :form="selectedRegion" @save="saveRegion" )
  app-dialog( v-model="isActionsDialogOpened" :header="`Регион - ${selectedRegion.title}`" :items="actions" )
  app-dialog-confirm( v-model="isDelActionOpened" @confirm="confirmDeleteRegion(selectedRegion.id)" )
    app-card-title.mt-5 Вы точно хотите удалить регион - {{ selectedRegion.title }} ?
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import ExpertAddRegionDialog from './dialogs/ExpertAddRegionDialog.vue'
import ExpertEditRegionDialog from './dialogs/ExpertEditRegionDialog.vue'
import ExpertRegionCard from './ExpertRegionCard.vue'
import { ExpertRegion } from './models/ExpertRegion.model'

export default {
  name: 'ExpertRegions',

  components: {
    ExpertAddRegionDialog,
    ExpertRegionCard,
    ExpertEditRegionDialog
  },

  data() {
    return {
      isAddRegionDialogOpened: false,
      isActionsDialogOpened: false,
      isDelActionOpened: false,
      isEditRegionDialogOpened: false,
      selectedRegion: new ExpertRegion()
    }
  },

  computed: {
    ...mapGetters('expert', ['hasRegions']),
    ...mapState('expert', ['regions']),

    fabItems() {
      return [{ icon:'add', title:'Добавить регион', action: () =>  this.openAddRegionDialog()}]
    },

    actions () {
      return [
        { title: 'Редактировать', icon: 'edit', action: () => this.openEditRegionDialog() }, 
        { title: 'Добавить суд в регион', icon: 'add', action: () => this.openAddCourtPage(this.selectedRegion.id) }, 
        { title: 'Удалить', icon: 'delete', action: () => this.openDeleteRegionDialog() }
      ]
    },
  },

  methods: {
    ...mapActions('expert', ['saveCourtRegion', 'deleteRegion']),

    openAddRegionDialog() {
      this.isAddRegionDialogOpened = true
    },

    openEditRegionDialog() {
      this.isEditRegionDialogOpened = true
    },

    openRegionActionsDialog(region) {
      this.selectedRegion = region
      this.isActionsDialogOpened = true
    },

    openAddCourtPage(regionId) {
      this.$router.push({ path: `/admin/expert/${regionId}` })
    },

    saveRegion($event) {
      this.saveCourtRegion($event)
    },

    openDeleteRegionDialog() {
      this.isDelActionOpened = true
    },

    confirmDeleteRegion(id) {
      if(id) this.deleteRegion(id)
    }, 
  }
}
</script>./dialogs/ExpertEditRegionDialog.vue